import React from 'react';
import { get, merge } from 'lodash';
import {  cloneDeep,  findIndex, isUndefined, noop, forEach, find, isEmpty, size } from 'lodash';
import { SERVICE_RESPONSE_STATUS, SIZES, } from 'constants/common';
// React view component to render
import { memberAllergiesInfo as MemberAllergiesInfoView } from 'ui/views/widgets/memberAllergiesInfo';
import { MemberAllergiesInfoService } from 'services/memberAllergiesInfo';
import { GLOBAL_LABELS } from 'constants/common';
import { OVERLAY_VIEWS } from 'constants/templates';
import { overlay } from 'modules/overlay';
import * as errorOverlay from 'utils/errorOverlay';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import * as successOverlay from 'utils/successOverlay';
import { getLabel } from 'utils/getLabel';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberAllergiesInfo } from 'ui/containers/MemberAllergiesInfo';
 *
 * // render
 * <MemberAllergiesInfo propName='propValue'/>
 */
export class MemberAllergiesInfo extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
            selectedAllergies: undefined,
            note: undefined,
            networkError: undefined,
            isAllergiesNotAtVerified:false ,
            isNoKnownDrugAllergies: false
        };

        // Member allergies info Service
        this.memberAllergiesInfoService = new MemberAllergiesInfoService();

        // bind methods to instance
        this.editClickHandler = this.editClickHandler.bind( this );

        // Member Allergies Info data fetch
        this.fetchComponentData();
    }

    /**************************************************** */

    /**
     * @desc Fetch member allergies info.
     */
    async fetchComponentData() {
       
        log.debug( 'MemberAllergiesInfo.fetchComponentData()' );

        // cancel ongoing request
        this.memberAllergiesInfoService.cancel();

        try {
            const { status, data }  = await this.memberAllergiesInfoService.fetchData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {

                this.setState( {
                    isFetching: false,
                    networkError: data,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );

            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    // open add edit form as well as call Add or Edit functionality depends upon the action
    async editClickHandler( { action } ) {
        log.debug( 'MemberAllergiesInfo.editClickHandler()' );

        // cancel ongoing request
        this.memberAllergiesInfoService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        // get status and service data
        const { status, data } = await this.memberAllergiesInfoService.fetchAddEditForm( {
            url: action.url,
            data: this.props.requestPayload
        } );

        // show page level preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            overlay.open( {
                settings: {
                    modalType: OVERLAY_VIEWS.ADD_EDIT_ALLERGIES,
                    showCloseButton: false,
                    ignoreOutsideClick: false,
                },
                config: {},
                data: {
                    ...data,
                    onCancelClick: () => {
                        overlay.close();
                    },
                    onUpdate: ( { selectedItems, note, isAllergiesNotAtVerified, isNoKnownDrugAllergies  } ) => {
                        this.setState( {
                            selectedAllergies: selectedItems,
                            note: note,
                            isAllergiesNotAtVerified: isAllergiesNotAtVerified,
                            isNoKnownDrugAllergies: isNoKnownDrugAllergies
                        } );
                    },
                    onSumbitClick: async () => {
                        overlay.close();
                        // show page level preloader
                        pageLevelPreloader.show();
                        console.log('this.state.selectedAllergies:::::', this.state.selectedAllergies);
                        console.log('this.state:::::::', this.state);
                        if( !this.state.isAllergiesNotAtVerified  && !this.state.isNoKnownDrugAllergies && this.state.selectedAllergies.length && 'none'==this.state.selectedAllergies[0] )  
                        {
                           pageLevelPreloader.hide();
                           errorOverlay.open( { message: 'Please select any one of above option ' , size: SIZES.SMALL } ) 
                        }else{
                        // get status and service data
                        const { _status } = await this.memberAllergiesInfoService.saveEditAllergies( {
                          url: action.config.submitUrl,
                            data: merge( {
                                data: {
                                    ids: this.state.selectedAllergies,
                                    note: this.state.note,
                                    isAllergiesNotAtVerified: this.state.isAllergiesNotAtVerified,
                                    isNoKnownDrugAllergies: this.state.isNoKnownDrugAllergies
                                   
                                } }, this.props.requestPayload )
                        } );
                    

                        // show page level preloader
                        pageLevelPreloader.hide();

                        // check if response status was success
                        if ( SERVICE_RESPONSE_STATUS.SUCCESS === _status ) {

                            // display success message
                            successOverlay.open( {
                                message: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_DONE_SUCCESSFULLY ),
                            } );
                            
                            // Member allergies Info data fetch
                            this.setState( {
                                isFetching: true,
                                networkStatus: undefined,
                            }, () =>  this.fetchComponentData() );

                           
                        } else {
                            errorOverlay.open(); // show error
                        }
                        }
                    },
                }
            } );
        }
    }

    /**
     * @desc When component unmounts, cleanup resources.
     */
    componentWillUnmount() {
        this.memberAllergiesInfoService.cancel(); // cancel ongoing requests
    }

    /*********************************************/

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberAllergiesInfoView
                isFetching= { this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                requestPayload={ this.props.requestPayload }
                { ...get( this.state, 'componentData', {} ) }
                onClickEdit={ this.editClickHandler }
                networkError={ this.state.networkError }
             />
        );
    }
}

// set display name
MemberAllergiesInfo.displayName = 'MemberAllergiesInfo';

// set default props
MemberAllergiesInfo.defaultProps = {};

// prop types
MemberAllergiesInfo.propTypes = {};
